<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_IS_GRANT_BEEN_DEVELOPMENT'
        )
      }"
    >
      <select
        :disabled="$parent.$parent.projectDisabled"
        v-model="project.SETTING_TABLE.allData.UF_IS_GRANT_BEEN_DEVELOPMENT"
        class="sel-dropdown i-main-style i-wid-13"
      >
        <option :value="0"></option>
        <option :value="1">Да</option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText(
            "PROJECTS",
            "LOGIC",
            "UF_IS_GRANT_BEEN_DEVELOPMENT"
          )
        }}
      </div>
    </div>
    <div
      class=""
      v-if="project.SETTING_TABLE.allData.UF_IS_GRANT_BEEN_DEVELOPMENT"
    >
      <br /><br />
      <p class="content-s-2-label">
        <label
          >Реквизиты документа, подтверждающего передачу конструкторской
          документации, выполненной по договору о предоставлении гранта:</label
        >
      </p>
      <div
        class="col-xs-12 mycol"
        :class="{
          'has-error': $parent.$parent.checkErrorField(
            'PROJECTS',
            'LOGIC',
            'UF_GRANT_DETAILS_DOCUMENT'
          )
        }"
      >
        <textarea
          class="i-main-style t-dop-style i-wid-50"
          v-model="project.SETTING_TABLE.allData.UF_GRANT_DETAILS_DOCUMENT"
          placeholder=""
          style="resize: vertical;"
        ></textarea>
        <div class="error-text">
          {{
            $parent.$parent.checkErrorText(
              "PROJECTS",
              "LOGIC",
              "UF_GRANT_DETAILS_DOCUMENT"
            )
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "uf_is_reg_fond_help",
  computed: {
    ...mapGetters(["directory", "project"])
  }
};
</script>

<style scoped></style>
